import { render, staticRenderFns } from "./CompletedScreeningMenu.vue?vue&type=template&id=08bff53d&scoped=true&"
import script from "./CompletedScreeningMenu.vue?vue&type=script&lang=js&"
export * from "./CompletedScreeningMenu.vue?vue&type=script&lang=js&"
import style0 from "./CompletedScreeningMenu.vue?vue&type=style&index=0&id=08bff53d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bff53d",
  null
  
)

export default component.exports